import _define_property from "@swc/helpers/src/_define_property.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Menu from "@material-ui/icons/Menu";
import Language from "@material-ui/icons/Language";
import HelpIcon from "@material-ui/icons/HelpOutline";
import clsx from "clsx";
import PopupState, { bindPopover, bindToggle } from "material-ui-popup-state";
import { useRouter } from "next/router";
import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import LineInfo from "../../components/line-info";
import UserInfo from "../../components/user-info";
import { VersionContext } from "../../contexts/version";
import { properties as navigationProperties } from "../../layout/navigation";
import Link from "../../link";
export var FIXED_HEADER_BREAKPOINT = "md";
var useStyles = makeStyles(function(theme) {
    var _obj, _obj1;
    return {
        // TODO: Factor this to supply a common interface with Anchor/Link.
        factorFakeAnchor: _define_property({
            color: "#FFB200",
            "&:hover *": {
                color: "#FFB200 !important"
            }
        }, theme.breakpoints.down("sm"), {
            minWidth: "auto"
        }),
        bar: {
            backgroundColor: theme.palette.primary.main,
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create([
                "width",
                "margin"
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            })
        },
        barShifted: {
            marginLeft: navigationProperties.width,
            width: "calc(100% - ".concat(navigationProperties.width, "px)"),
            transition: theme.transitions.create([
                "width",
                "margin"
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        },
        logo: (_obj = {
            display: "inline-block"
        }, _define_property(_obj, theme.breakpoints.up("sm"), {
            height: 40
        }), _define_property(_obj, theme.breakpoints.down("xs"), {
            height: 26
        }), _define_property(_obj, "paddingLeft", 16), _define_property(_obj, "verticalAlign", "middle"), _define_property(_obj, "& > svg", {
            height: "100%"
        }), _define_property(_obj, theme.breakpoints.down("sm"), {
            paddingLeft: 0
        }), _obj),
        title: {
            flex: 1,
            textOverflow: "clip"
        },
        menuButton: (_obj1 = {
            marginLeft: 12
        }, _define_property(_obj1, theme.breakpoints.down("sm"), {
            marginLeft: 8
        }), _define_property(_obj1, "transition", theme.transitions.create([
            "width",
            "margin",
            "padding"
        ], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })), _define_property(_obj1, "overflow", "hidden"), _obj1),
        hideSmooth: {
            width: 0,
            margin: 0,
            padding: 0
        },
        hide: {
            display: "none"
        },
        rightsideGuttersSmall: {
            paddingRight: 8
        },
        rightsideGuttersLarge: {
            paddingRight: 16
        },
        loggedInInfo: {
            lineHeight: "100%",
            textAlign: "right"
        },
        loggedInEmail: {
            fontSize: "10px"
        },
        stagingStriped: {
            backgroundImage: "repeating-linear-gradient(-45deg, ".concat(theme.palette.primary.main, ", ").concat(theme.palette.primary.main, " 10px, rgba(255, 255, 255, 0.075) 10px, rgba(255, 255, 255, 0.075) 20px)")
        },
        verticalAlignMiddle: {
            verticalAlign: "middle"
        },
        language: _define_property({
            marginRight: "5px"
        }, theme.breakpoints.down("xs"), {
            display: "none"
        }),
        text: {
            color: theme.palette.getContrastText(theme.palette.primary.main),
            textTransform: "uppercase"
        },
        rightPadding: _define_property({
            paddingRight: "1em"
        }, theme.breakpoints.down("sm"), {
            paddingRight: "0.5em"
        }),
        changeLanguageProgress: {
            color: "#ffb200",
            position: "absolute",
            top: "-2px",
            left: "-2px",
            zIndex: 1
        },
        wrapper: {
            position: "relative",
            display: "inline-block"
        },
        lineDescription: {
            fontSize: "10px"
        },
        helpIcon: {
            color: "white",
            "&:hover *": {
                color: "#FFB200 !important"
            }
        },
        buttonPadding: _define_property({}, theme.breakpoints.down("sm"), {
            padding: 5
        })
    };
});
var Header = function(param) {
    var openNavigation = param.openNavigation, isNavigationOpen = param.isNavigationOpen, isAuthPage = param.isAuthPage, dashboardMenu = param.dashboardMenu, _availableLanguages = param.availableLanguages, availableLanguages = _availableLanguages === void 0 ? {
        "en-GB": {
            nativeName: "English"
        }
    } : _availableLanguages;
    var router = useRouter();
    var ref = useState(false), isLoadingLanguage = ref[0], setLoadingLanguage = ref[1];
    var classes = useStyles();
    var ref1 = _sliced_to_array(useTranslation(), 2), t = ref1[0], i18n = ref1[1];
    var ref2 = useContext(VersionContext), commit = ref2.commit, version = ref2.version;
    var handleChangeLanguage = useCallback(function(languageCode, cb) {
        setLoadingLanguage(true);
        if (i18n) {
            // In the newest i18n version use promise instead of callback.
            i18n.changeLanguage(languageCode, function(err, _t) {
                setLoadingLanguage(false);
                // Force reload to make sure language change takes effect.
                window.location.reload();
                if (err) {
                    console.error("Error changing language: ".concat(err));
                }
            });
        }
        cb();
    }, [
        i18n
    ]);
    var handleLangClick = useCallback(function(lang, cb) {
        return function() {
            return handleChangeLanguage(lang, cb);
        };
    }, []);
    var userInfo = !isAuthPage ? /*#__PURE__*/ React.createElement(Hidden, {
        smDown: true
    }, /*#__PURE__*/ React.createElement(UserInfo, {
        className: classes.rightPadding,
        alignRight: true
    })) : null;
    var lineInfo = !isAuthPage ? /*#__PURE__*/ React.createElement(LineInfo, {
        className: classes.rightPadding,
        t: t,
        alignRight: true
    }) : null;
    var pathname = router.pathname;
    var currentLanguage = function() {
        var currentLanguage = i18n && i18n.language || "en-GB";
        return availableLanguages[currentLanguage] ? currentLanguage : "en-GB";
    }();
    var languagePicker = /*#__PURE__*/ React.createElement(PopupState, {
        variant: "popover",
        popupId: "languagePicker"
    }, function(popupState) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, Object.assign({
            className: clsx(classes.factorFakeAnchor, classes.buttonPadding)
        }, bindToggle(popupState)), /*#__PURE__*/ React.createElement(Typography, {
            className: classes.text,
            variant: "body2"
        }, /*#__PURE__*/ React.createElement("span", {
            className: clsx(classes.language, classes.verticalAlignMiddle)
        }, availableLanguages[currentLanguage].nativeName), /*#__PURE__*/ React.createElement("span", {
            className: clsx("rtl-padding-right", classes.wrapper)
        }, /*#__PURE__*/ React.createElement(Language, {
            className: classes.verticalAlignMiddle
        }), isLoadingLanguage && /*#__PURE__*/ React.createElement(CircularProgress, {
            size: 28,
            thickness: 3,
            className: classes.changeLanguageProgress
        })))), /*#__PURE__*/ React.createElement(Popover, Object.assign({}, bindPopover(popupState), {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right"
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "right"
            }
        }), /*#__PURE__*/ React.createElement(Paper, null, /*#__PURE__*/ React.createElement(MenuList, null, Object.keys(availableLanguages).map(function(lang) {
            return /*#__PURE__*/ React.createElement(MenuItem, {
                key: lang,
                onClick: handleLangClick(lang, popupState.close)
            }, availableLanguages[lang].nativeName);
        })))));
    });
    var navigationButton = !isAuthPage ? /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "Menu",
        onClick: openNavigation,
        className: clsx(classes.menuButton, classes.text, classes.factorFakeAnchor, isNavigationOpen && classes.hideSmooth)
    }, /*#__PURE__*/ React.createElement(Menu, null)) : null;
    var theme = useTheme();
    var smallScreen = useMediaQuery(theme.breakpoints.down("md"));
    var isDashboardPage = pathname === null || pathname === void 0 ? void 0 : pathname.startsWith("/dashboard");
    var helpIcon = !isAuthPage ? /*#__PURE__*/ React.createElement(IconButton, {
        component: Link,
        href: "/help",
        "aria-label": "help",
        className: classes.helpIcon
    }, /*#__PURE__*/ React.createElement(HelpIcon, null)) : null;
    var isStaging = !!(version && !/^v\d+\.\d+\.\d+$/.test(version));
    return /*#__PURE__*/ React.createElement(AppBar, {
        color: "primary",
        className: clsx(classes.bar, isNavigationOpen && classes.barShifted, _define_property({}, classes.stagingStriped, isStaging)),
        position: smallScreen || isDashboardPage ? "absolute" : "fixed"
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        disableGutters: true,
        className: smallScreen && classes.rightsideGuttersSmall || classes.rightsideGuttersLarge
    }, navigationButton, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "inherit",
        className: classes.title,
        noWrap: true
    }, /*#__PURE__*/ React.createElement(Link, {
        href: "/"
    }, /*#__PURE__*/ React.createElement("img", {
        className: clsx(classes.logo, isNavigationOpen && smallScreen && classes.hide),
        src: "/images/logo.svg"
    }))), isDashboardPage ? dashboardMenu : null, isDashboardPage ? lineInfo : userInfo, languagePicker, helpIcon));
};
export default Header;
